import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { ConfigService } from '@polaris-customerweb/sharedcomponents.config';
import { RoutingHelpersService } from '@polaris-customerweb/sharedcomponents.shared';
import { Observable, of } from 'rxjs';
import { switchMap, take } from 'rxjs/operators';
import { UserAuthService } from './user-auth.service';

export const epiGarageRedirectGuard: CanActivateFn =
    (): Observable<boolean> => {
        const configService = inject(ConfigService);
        const userAuthService = inject(UserAuthService);
        const routingHelpersService = inject(RoutingHelpersService);

        return userAuthService.isAuthenticated$.pipe(
            take(1),
            switchMap((isAuthenticated) => {
                if (configService.isEmbedded && !isAuthenticated) {
                    window.location.href = routingHelpersService.combineUrl(
                        configService.siteUrl,
                        'garage/'
                    );

                    return of(false);
                }

                return of(true);
            })
        );
    };
